var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 614,
    height: 586,
    viewBox: "0 0 614 586",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300.64 2.63246C304.154 -0.877488 309.846 -0.877488 313.36 2.63246L472.69 161.784C478.362 167.449 488.052 163.432 488.052 155.417V123.223C488.052 118.253 492.081 114.223 497.052 114.223H542.025C546.996 114.223 551.025 118.253 551.025 123.223V236.299C551.025 238.688 551.975 240.979 553.665 242.668L611.36 300.298C613.05 301.986 614 304.276 614 306.665V333.249C614 338.219 609.971 342.249 605 342.249H575.77C570.799 342.249 566.77 346.278 566.77 351.249V577.001C566.77 581.971 562.74 586 557.77 586.001H56.2305C51.26 586 47.2305 581.971 47.2305 577.001V351.249C47.2302 346.278 43.2009 342.249 38.2305 342.249H9C4.02944 342.249 0 338.219 0 333.249V306.665C0.000128703 304.276 0.949748 301.986 2.63965 300.298L300.64 2.63246ZM307 231.959C207.005 231.959 125.948 294.429 125.948 371.478C125.948 448.527 207.006 510.997 307 510.997C330.537 510.997 352.987 507.526 373.627 501.248C405.069 523.454 405.069 530.928 457.876 530.928C437.339 510.997 433.15 503.844 435.244 471.134C466.638 446.038 488.051 409.096 488.051 371.478C488.051 294.429 406.994 231.959 307 231.959Z",
    fill: "url(#paint0_linear_310_1634)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_310_1634",
    x1: 644.541,
    y1: 137.059,
    x2: 42.1932,
    y2: 114.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#097FE6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLogo);
export default __webpack_public_path__ + "static/media/login-logo.f795fe496bfdfb504d4977540dc52702.svg";
export { ForwardRef as ReactComponent };